<template>
  <v-app>
    <template slot="progress">
      <v-progress-linear
        color="success"
        height="10"
        indeterminate
      ></v-progress-linear>
    </template>
    <v-btn
      class="back_to_top_btn pa-1 animate__animated"
      @click="topFunction"
      color=" var(--white-color)"
      id="back_to_top"
      icon
      large
      elevation="2"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 512 512"
        fill="white"
        font-size="20"
      >
        <path
          d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
        />
      </svg>
    </v-btn>
    <v-main>
      <transition name="moveInUp">
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return { fab: false, fabback: false, doc: null };
  },
  components: {},
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 200;
    },
    onScrollTop(e) {
      if (typeof window === "undefined") return;
      const back = window.pageYOffset || e.target.scrollTop || 0;
      this.fabback = back < 200;
    },
    toBack() {
      this.$router.push({
        name: "booths",
      });
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    login() {
      this.$gtag.event("login", { method: "Google" });
    },
    // track() {
    //   this.$gtag.event(<action>, {
    //     'event_category': <category>,
    //     'event_label': <label>,
    //     'value': <value>
    //   })
    // }
  },
  mounted() {
    this.login();
  },
  setup() {
    window.onscroll = function () {
      scrollFunction();
    };

    function scrollFunction() {
      let mybutton = document.getElementById("back_to_top");
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        if (mybutton) {
          mybutton.style.display = "block";
          mybutton.classList.add("animate__zoomIn", "animate__faster");
        }
      } else {
        if (mybutton) {
          mybutton.classList.remove("animate__zoomIn", "animate__faster");
          mybutton.classList.add("animate__rollOut");
        }
      }
    }

    function topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }

    return {
      topFunction,
    };
  },
};
</script>
<style lang="css">
@import url(../src/assets/fonts/font.css);
@import url(../src/assets/fonts/fontiran.css);
@import url(primevue/resources/themes/saga-blue/theme.css);
@import url(primevue/resources/primevue.min.css);
@import url(primeicons/primeicons.css);

html {
  scroll-behavior: smooth;
}
:root {
  /* Palette */
  --primary-color-t3: #7b2cbf;
  --secondery-color-t3: #9d59d9;
  --third-color-t3: #f49f0a;
  --light-third-color-t3: #f8ba4f;
  --combine-pr-th-color-t3: #bf7573;

  /* Additional color */
  --footer-color-t3: #8c43cc;
  --accent-color-t3: #6c757d;
  --white-color-t3: #ffffff;
  --dark-color-t3: #343a40;
  --flash-white-color-t3: #f2f3f5;
  --light-color-t3: #f1f5f8;
  --white-primary-color-t3: #e2cdf4;
  --light-primary-color-t3: #c49be8;
  --black-color-t3: #0a0908;

  /* Gold Palette */
  --orange-web: #e69800;
  --selective-yellow: #e6aa00;
  --mikado-yellow: #e6b000;
  --jonquil: #e6bc00;
  --school-bus-yellow: #e6c700;

  /* Palette */
  --primary-color: #1f61eb;
  --secondery-color: #1d8fe1;
  --accent-color: #6c757d;

  /* Additional color */
  --white-primary-color: #22e1ff;
  --light-primary-color: #7ca2f4;
  --ice-color: #c7d7fa;
  --black-color: #0a0908;
  --dark-color: #343a40;
  --white-color: #ffffff;
  --flash-white-color: #f2f3f5;
  --light-color: #f1f5f8;
  /* Palette */
  --primary-color-st1: #d7a741;
  --light-primary-color-st1: #dfb968;
  --secondery-color-st1: #be9368;
  --light-secondery-color-st1: #cead8d;
  --third-color-st1: #78797d;

  /* Additional color */
  --white-color-st1: #ffffff;
  --dark-color-st1: #161719;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #f5f5f5;
  border-radius: 10px;
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #fff;
  background-image: linear-gradient(
    219deg,
    rgba(10, 171, 148, 1) 35%,
    rgba(95, 188, 94, 1) 100%
  );
}
.v-btn {
  letter-spacing: 0px !important;
}
.v-application {
  font-family: IRANSansX, iranyekan !important;
  letter-spacing: 0px;
}
.v-application .text-h6 {
  font-size: 14px !important;
  font-weight: 500;
  line-height: 1rem;
  letter-spacing: 0 !important;
  font-family: IRANSansX !important;
}
/* * {
  font-family: IRANSansX !important;
} */
html {
  font-size: 14px;
  letter-spacing: 0px;
}
body {
  font-family: IRANSansX !important;
  direction: rtl;
  background-color: #cdcdcd;
  margin: 0;
  letter-spacing: 0px !important;
}
h1,
h2,
h3,
h4,
h5,
h6,
input,
textarea {
  font-family: IRANSansX !important;
}
h1 {
  font-weight: bold;
}
.wrapper {
  max-width: 900px;
  margin: 0 auto;
}
.ltr {
  direction: ltr;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-small {
  font-size: 0.8em;
}
.text-xsmall {
  font-size: 0.6em;
}
.text-large {
  font-size: 1.2em;
}
.text-xlarge {
  font-size: 1.4em;
}
.text-underline {
  text-decoration: underline;
}

.text-thin {
  font-weight: 100;
}
.text-UltraLight {
  font-weight: 200;
}
.text-light {
  font-weight: 300;
}
.text-regular {
  font-weight: normal;
}
.text-medium {
  font-weight: 500;
}
.text-demibold {
  font-weight: 600;
}
.text-bold {
  font-weight: bold;
}

.text-extrabold {
  font-weight: 800;
}
.text-black {
  font-weight: 900;
}
.mapboxgl-user-location-dot::before {
  background-color: rgba(95, 188, 94, 1) !important;
}
.mapboxgl-user-location-dot {
  background-color: rgba(95, 188, 94, 1) !important;
}
.moveInUp-enter-active {
  opacity: 0;
  transition: opacity 0.3s ease-in;
}
.moveInUp-enter-active {
  animation: fadeIn 0.3s ease-in;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.moveInUp-leave-active {
  animation: moveInUp 0.3s ease-in;
}
@keyframes moveInUp {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-400px);
  }
}

/* backtotop */
.back_to_top_btn {
  position: fixed;
  display: none;
  right: 10px;
  bottom: 10px;
  background-image: linear-gradient(
    135deg,
    var(--white-primary-color) 0%,
    var(--light-primary-color) 55%,
    var(--primary-color) 100%
  );
  z-index: 200;
}

.back_to_top_btn .v-icon {
  font-size: 20px !important;
  margin: 6px 0;
}

/*
>>--------------------<<
    Responsive style
>>--------------------<<
*/

@media (max-width: 770px) {
  .back_to_top_btn {
    display: none !important;
  }
} ;
</style>
